<small class="debug">{{ me }}</small>
@if (isTouchMode) {
    <div class="touch-playlist-ui">
        <div class="playlist-header">
            <mat-icon class="playlist-icon">playlist_play</mat-icon>
            <div class="playlist-info">
                <div class="playlist-name">{{ sceneItem?.$.label || 'Playlist' }}</div>
                <div class="playlist-duration">{{ sceneItem?.Data?.[0]?.Playlist?.[0]?.$.duration || '5' }}
                    s {{ 'ai.default' | transloco }}
                </div>
            </div>
        </div>

        <div class="playlist-stats">
            <div class="stat-item">
                <mat-icon>video_library</mat-icon>
                <span>{{ sceneItem?.Data?.[0]?.Playlist?.[0]?.Page?.length || 0 }} {{ 'ai.items' | transloco }}</span>
            </div>
            <div class="stat-item" *ngIf="sceneItem?.Data?.[0]?.Playlist?.[0]?.Page?.length">
                <mat-icon>schedule</mat-icon>
                <span>{{ getTotalPlaylistTime() }}s {{ 'ai.total' | transloco }}</span>
            </div>
        </div>

        <!--    <div class="playlist-actions">-->
        <!--      <button mat-stroked-button class="action-btn" (click)="onPlaylistTimeline()">-->
        <!--        <mat-icon>timeline</mat-icon>-->
        <!--        {{ 'ai.expand' | transloco }}-->
        <!--      </button>-->
        <!--    </div>-->

    </div>
} @else {
    <div class="playlist_properties">
        <!--    <app-video-link-->
        <!--            tooltip="{{'general.timeline' | transloco}}"-->
        <!--            style="position: fixed; top: -10px; width: 50px; height: 50px"-->
        <!--            [videoLink]="'/help/Playlist'"></app-video-link>-->
        <div class="clearFloat"></div>
        @if (dynamicsInitialized) {
            <div>
                <dynamic-form
                    [fields]="uiConfigInit"
                    [ignoreValidation]="true"
                    (submit)="submit($event)">
                </dynamic-form>
            </div>
        }
    </div>
}
